import { IUserProfileTenant } from 'features/userProfileApps/UserProfileApps';

export enum PackageAssignmentPage {
    UserGroup = 'UserGroup',
    User = 'User',
    License = 'License',
    UserProfile = 'UserProfile',
}

export interface PackageAssignmentDrawerProperties {
    tenantId: string;
    tenantName: string;
    tenantRequiresLicense: boolean;
    page: PackageAssignmentPage;
    principalId?: string;
    principalName?: string;
    licenseId?: string;
    licenseName?: string;
    currentUserProfileTenant?: IUserProfileTenant;
}
